<template lang="pug">
div
  .filter-resources(:class="isSectionTranslatable('Filter - Resources')")
    .heading.mb-M
      h2.h2 Filter - Resources
    label Show
    briq-required-and-optional-markers(:isRequired="false" label="show")
    .filter-resources-checkboxes-holder
      .checkbox-holder(v-for="(activity, key) in resourceFilters")
        BriqCheckbox.resources-checkbox(
          v-if="activity.parentResourceKey === null"
          :label="resourceFilters[key].label" 
          v-model="resourceFilters[key].value" 
          :key="key" 
          :style="checkboxStyle"
          )
        .child-resources 
          BriqCheckbox.resources-checkbox(
            v-for="(childResources) in activity.childResources"
            :label="resourceFilters[childResources.Key].label" 
            v-model="resourceFilters[childResources.Key].value" 
            :key="childResources.Key" 
            :style="checkboxStyle"
            )
  .separator
  CustomFilters(:filters="shopSettings.Filters" :translationInfo="shopSettings.TranslationInfo" :validations="this.$v.shopSettings.Filters" :showTranslations="!isEmpty(translationSections)")
  .separator
  ThemeSelector(:themes="shopSettings.Theme" :translationInfo="shopSettings.TranslationInfo" :validations="this.$v.shopSettings.Theme" :showTranslations="!isEmpty(translationSections)")
</template>

<script>
import CustomFilters from '@v/settings/application/shop/CustomFilters.vue'
import ThemeSelector from '@v/settings/application/shop/ThemeSelector.vue'
import { required } from 'vuelidate/lib/validators'
import { isEmpty } from 'ramda'

export default {
  components: {
    ThemeSelector,
    CustomFilters,
  },
  props: {
    shopSettings: Object,
    resourceFilters: Object,
    translationSections: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      errorMessage: 'This field is required',
      checkboxStyle: 'margin-bottom: 0px',
    }
  },
  methods: {
    isEmpty: isEmpty,
    isSectionTranslatable(section) {
      return !isEmpty(this.translationSections) && !this.translationSections.includes(section)
        ? 'hidden'
        : ''
    },
  },
  validations() {
    return {
      shopSettings: {
        Theme: {
          $each: {
            name: { required },
          },
        },
        Filters: {
          $each: {
            name: { required },
            rows: {
              $each: {
                name: { required },
              },
            },
          },
        },
      },
    }
  },
}
</script>

<style scoped lang="stylus">
.filter-resources-checkboxes-holder
  border 1px solid #F1F3F6
  padding 15px
  border-radius 3px
  margin-bottom 20px

.heading
  display flex
  justify-content space-between

.separator
  border-bottom 1px solid #F1F3F6
  margin-top 10px
  margin-bottom 25px

.resources-checkbox
  margin 0

.child-resources
  margin-left 30px
</style>
